/**
 * Constant for the recommendations request.
 *
 * @public
 */
export const RECOMMENDATIONS_ORIGIN = 'default'
